import type { ReactNode } from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface PageShellProps {
  title: string;
  children: ReactNode;
}

/**
 * Generic full-page shell with a centred title heading and constrained-width
 * content area. Mirrors the visual structure of the admin dashboard layout.
 */
const PageShell = ({ title, children }: PageShellProps) => (
  <Box
    component="main"
    sx={(theme) => ({
      flex: 1,
      px: { xs: 2, sm: 4 },
      py: { xs: 4, sm: 6 },
      bgcolor: theme.palette.mode === 'dark' ? 'background.default' : theme.palette.grey[100],
    })}
  >
    <Stack spacing={{ xs: 5, sm: 8 }}>
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 700,
          color: 'text.primary',
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
      {children}
    </Stack>
  </Box>
);

export default PageShell;
